export enum VisitorType {
  NormalUser = 'normal_user',
  LegitBot = 'legit_bot',
  Scraper = 'scraper',
}

export enum ReferrerType {
  Direct = 'direct',
  Internal = 'internal',
  External = 'external',
}
